module.exports = __webpack_public_path__ + "img/reward.8412e8fc.svg";